import React from 'react';
import { useTranslation } from 'react-i18next';
import './AboutPage.css';

const AboutPage = () => {
  const { t } = useTranslation();
  
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1 className="hero-title" data-aos="fade-up">{t('about.pageTitle')}</h1>
        </div>
      </section>

      {/* A origem do cuidado Section */}
      <section className="about-section">
        <div className="container">
          <div className="section-content">
            <div className="section-text" data-aos="fade-right">
              <h2 className="section-title">{t('about.originTitle')}</h2>
              <p className="section-paragraph">
                {t('about.originText')}
              </p>
            </div>
            <div className="section-image" data-aos="fade-left">
              <picture>
                <source type="image/webp" srcSet="/images/sbr_01.webp" />
                <img src="/images/sbr_01.png" alt={t('about.originTitle')} />
              </picture>
            </div>
          </div>
        </div>
      </section>

      {/* Por que existimos Section */}
      <section className="about-section alt-background">
        <div className="container">
          <div className="section-content reverse">
            <div className="section-image" data-aos="fade-right">
              <picture>
                <source type="image/webp" srcSet="/images/sbr_02.webp" />
                <img src="/images/sbr_02.png" alt={t('about.whyTitle')} />
              </picture>
            </div>
            <div className="section-text" data-aos="fade-left">
              <h2 className="section-title">{t('about.whyTitle')}</h2>
              <p className="section-paragraph">
                {t('about.whyText')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* O que nos move Section */}
      <section className="about-section">
        <div className="container">
          <div className="section-content">
            <div className="section-text" data-aos="fade-right">
              <h2 className="section-title">{t('about.driveTitle')}</h2>
              <p className="section-paragraph">
                {t('about.driveText')}
              </p>
            </div>
            <div className="section-image" data-aos="fade-left">
              <picture>
                <source type="image/webp" srcSet="/images/sbr_03.webp" />
                <img src="/images/sbr_03.png" alt={t('about.driveTitle')} />
              </picture>
            </div>
          </div>
        </div>
      </section>

      {/* A nossa promessa Section */}
      <section className="about-section alt-background">
        <div className="container">
          <div className="section-content reverse">
            <div className="section-image" data-aos="fade-right">
              <picture>
                <source type="image/webp" srcSet="/images/sbr_04.webp" />
                <img src="/images/sbr_04.png" alt={t('about.promiseTitle')} />
              </picture>
            </div>
            <div className="section-text" data-aos="fade-left">
              <h2 className="section-title">{t('about.promiseTitle')}</h2>
              <p className="section-paragraph">
                {t('about.promiseText')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <section className="quote-section">
        <div className="container">
          <blockquote className="quote-text" data-aos="fade-up">
            "{t('about.quote')}"
          </blockquote>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;

